<template>
<div class="chapter">
<div class="inner_page">
<p class="h4">Contents</p>
<p class="toc"><a href="#/preface">Preface</a></p>
<p class="toc1"><a href="#/chapter01">Chapter 1. William Lloyd Garrison</a></p>
<p class="toc1"><span href="#/chapter02" title="Link target outside of Sample">Chapter 2. Frederick Douglass’s Visit</span></p>
<p class="toc1"><span href="#/chapter03" title="Link target outside of Sample">Chapter 3. Underground Operative</span></p>
<p class="toc1"><span href="#/chapter04" title="Link target outside of Sample">Chapter 4. A Notable Statesman</span></p>
<p class="toc1"><span href="#/chapter05" title="Link target outside of Sample">Chapter 5. Albert W. Bartlett and the Cushing Guards</span></p>
<p class="toc1"><span href="#/chapter06" title="Link target outside of Sample">Chapter 6. Ships and the Port</span></p>
<p class="toc1"><span href="#/chapter07" title="Link target outside of Sample">Chapter 7. Citizen Soldiers</span></p>
<p class="toc1"><span href="#/chapter08" title="Link target outside of Sample">Chapter 8. Not All Defended the Union</span></p>
<p class="toc1"><span href="#/chapter09" title="Link target outside of Sample">Chapter 9. Homefront Newburyport</span></p>
<p class="toc1"><span href="#/chapter10" title="Link target outside of Sample">Chapter 10. April 1865: Great News and Horrible News</span></p>
<p class="toc1"><span href="#/chapter11" title="Link target outside of Sample">Chapter 11. Yankee Homecoming</span></p>
<p class="toc1"><span href="#/chapter12" title="Link target outside of Sample">Chapter 12. Postwar Years</span></p>
<p class="toc2"><span href="#/conclusion" title="Link target outside of Sample">Conclusion</span></p>
<p class="toc1"><span href="#/notes" title="Link target outside of Sample">Notes</span></p>
<p class="toc1"><span href="#/bibliography" title="Link target outside of Sample">Bibliography</span></p>
<p class="toc1"><span href="#/abouttheauthor" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?4a227850